import InputField from "components/fields/InputField";
import { FcGoogle } from "react-icons/fc";
import Checkbox from "components/checkbox";
import { useState, useEffect } from "react";
import { message } from "utils/Funciones";
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import io from "socket.io-client"
import { login, SET_TO_DEFAULT_RESPONSE } from "../../store/features/slices/userSlice";
import { Button, IconButton } from "@chakra-ui/react";
import { FaDoorOpen, FaKey, FaMailchimp, FaUser } from "react-icons/fa6";
import { FaMailBulk } from "react-icons/fa";
import { IoEye, IoEyeOff, IoMail } from "react-icons/io5";

export default function SignIn() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [VerPasswords, SetVerPasswords] = useState(
    {
      password: false,
    });

  const { isMutation } = useSelector((state) => state.userReducer);

  const [state, setState] = useState({
    email: '',
    password: ''
  })

  const handleInputs = e => {
    setState({ ...state, [e.target.name]: e.target.value })
  }

  const adminLoginFunction = e => {
    e.preventDefault();
    dispatch(login(state));
  }

  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      {/* Sign in section */}
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Ingreso al sistema
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Ingresa tu email y contraseña para ingresar!
        </p>
        <div className="mb-6 flex h-[50px] w-full items-center justify-center gap-2 rounded-xl bg-lightPrimary hover:cursor-pointer dark:bg-navy-800">
          <div className="rounded-full text-xl">
            <FcGoogle />
          </div>
          <h5 className="text-sm font-medium text-navy-700 dark:text-white">
            Ingresar con Google
          </h5>
        </div>
        <div className="mb-6 flex items-center  gap-3">
          <div className="h-px w-full bg-gray-200 dark:bg-navy-700" />
          <p className="text-base text-gray-600 dark:text-white"> o </p>
          <div className="h-px w-full bg-gray-200 dark:bg-navy-700" />
        </div>
        <form onSubmit={adminLoginFunction}>
          {/* Email */}
          <InputField
            iconleft={<FaUser size={24} className="text-brand-500 dark:text-brand-400" />}
            state={isMutation.success ? 'success' : isMutation.error && 'error'}
            required={true}
            variant="auth"
            extra="mb-3"
            label="Email o DNI"
            placeholder="Email o DNI"
            id="email"
            type="text"
            name="email"
            onChange={handleInputs}
            value={state.email}
          />

          {/* Password */}
          <InputField
            iconleft={<FaKey size={24} className="text-brand-500 dark:text-brand-400" />}
            iconright={<IconButton colorScheme={'brand'} onClick={() => SetVerPasswords({ ...VerPasswords, ['password']: !VerPasswords.password })} type="button">
              {VerPasswords.password ? <IoEyeOff size={24} className="!text-brand-500 dark:!text-brand-400" /> : <IoEye size={24} className="!text-brand-500 dark:!text-brand-400" />}
            </IconButton>}
            state={isMutation.success ? 'success' : isMutation.error && 'error'}
            required={true}
            variant="auth"
            extra="mb-3"
            label="Contraseña"
            placeholder="Min. 8 caracteres"
            id="password"
            type={VerPasswords.password ? 'text' : 'password'}
            name="password"
            onChange={handleInputs}
            value={state.password}
          />
          {/* Checkbox */}
          <div className="mb-4 flex items-center justify-between px-2">
            <div className="flex items-center">
              <Checkbox />
              <p className="ml-2 text-sm font-medium text-navy-700 dark:text-white">
                Manterme conectado
              </p>
            </div>
            <a
              className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
              href=" "
            >
              Olvidaste tu contraseña?
            </a>
          </div>
          <Button isLoading={isMutation.loading ? true : false} loadingText="validando datos" leftIcon={<FaDoorOpen size={24} />} type="submit" colorScheme={'brand'} className="linear !h-14 mt-2 w-full rounded-xl bg-brand-500 !py-[14px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
            ingresar
          </Button>
        </form>

      </div>
    </div>
  );
}
